var styles = {
  "ExitActionWrapper": "Online-Store-UI-ExitAction__ExitActionWrapper_hfcqh",
  "ExitAction": "Online-Store-UI-ExitAction_k4vtj",
  "animated": "Online-Store-UI-ExitAction--animated_cv13v",
  "Content": "Online-Store-UI-ExitAction__Content_glcku",
  "Label": "Online-Store-UI-ExitAction__Label_1ibis",
  "IconWrapper": "Online-Store-UI-ExitAction__IconWrapper_1xsxo",
  "ChildrenWrapper": "Online-Store-UI-ExitAction__ChildrenWrapper_1ub51"
};

export { styles as default };
